// BottomNavigationBarView ボトムナビゲーションを管理
class BottomNavigationBarView {
  static register(element) {
    return new BottomNavigationBarView(element)
  }

  constructor(element) {
    this.element = element

    this.assignEvent()
    this.initialize()
    this.hideTimeout = setTimeout(() => {
      return this.hide()
    }, 3000)
  }

  initialize() {
    if (!this.element.hasClass('visible')) {
      return this.element.css({ bottom: this.hiddenBottom() })
    }
  }

  hiddenBottom() {
    return 10 - this.element.height()
  }

  hide() {
    this.element.animate({ bottom: this.hiddenBottom() }, { duration: 400 })
    return this.element.removeClass('visible')
  }

  toggle() {
    let bottom
    if (this.element.hasClass('visible')) {
      bottom = this.hiddenBottom()
    } else {
      bottom = 0
    }

    this.element.animate({ bottom }, { duration: 100 })
    return this.element.toggleClass('visible')
  }

  setViewState(leaflet) {
    $('.leaflet_image').removeClass('highlighted')
    return $(`.leaflet_image_${leaflet.id}`).addClass('highlighted')
  }

  assignEvent() {
    this.element.on('click', '.arrows', () => {
      return this.toggle()
    })

    return this.element.on('hover', () => {
      return clearTimeout(this.hideTimeout)
    })
  }
}

export default BottomNavigationBarView;
